// ─── Tiempo de entrega de una cotización ─────────────────────────────────────
// Se captura como un NÚMERO de días hábiles —no como texto libre— para que la
// cotización siempre diga "días hábiles" y no quede a criterio de quien la
// escribe ("10 días", "2 semanas", "10 dias habiles"…). Es obligatorio: el
// cliente necesita saber en cuánto se le entrega.
//
// Las cotizaciones anteriores a este cambio guardaron texto libre en el mismo
// campo; esas se imprimen tal cual quedaron, sin inventarles un número.
export function textoTiempoEntrega(valor) {
  if (valor == null || String(valor).trim() === "") return "";
  const bruto = String(valor).trim();
  if (!/^\d+$/.test(bruto)) return bruto;          // valor antiguo escrito a mano
  const n = Number(bruto);
  return n === 1 ? "1 día hábil" : `${n} días hábiles`;
}
